import type { FC } from 'react';
import { PromoField } from '@/components/PromoField/PromoField';
import type { PromoCodeFieldProps } from './PromoCodeField.types';
import styles from './PromoCodeField.module.scss';
export const PromoCodeField: FC<PromoCodeFieldProps> = ({
  name,
  value,
  className,
  analytics,
  onChange,
  currency
}) => {
  return <div className={cn(styles.root, className)} data-sentry-component="PromoCodeField" data-sentry-source-file="PromoCodeField.tsx">
      <PromoField variant="auth" mode="check" name={name} value={value} analytics={analytics} disableInitialTooltip onChange={onChange} currency={currency} data-sentry-element="PromoField" data-sentry-source-file="PromoCodeField.tsx" />
    </div>;
};